<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Deposit</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/depositordetails/add"> -->
          <button  (click)="add()"class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <!-- <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>Generate Output </span>
        </button>
      </span> -->
    </div>
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-3">
                <label>Name of the depositor</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="nameOfDepositor" name="nameOfDepositor" class="form-control">
                </div>
              </div>
  
              <!-- <div class="col-md-3">
                <label>Date of Deposit is repayable</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From Date:&nbsp;
                  <input id="dateOfRepayable" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfRepayable" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfRepayable">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div> -->
  
              <!-- <div class="col-md-3">
                <label>Date of Deposit</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To Date:&nbsp;
                  <input id="dateOfDeposit" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfDeposit" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfDeposit">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div> -->
  
  
  
  
  
  
  
              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]=" dtTriggerRegister"
                class="table table-hover compact cell-border nowrap stripe" id="depositorlistTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th> Name of the depositor </th>
                    <th> Date of Deposit</th>
                    <th>Type of Deposit </th>
                    <th>Amount of Deposit</th>
                    <th>Deposit Receipt No.</th>
                    <th>Depositor Type</th>
                  
                    <th class="actionclass">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of depositDetailList; ">
                    <td>
                      {{director.nameOfDepositor}}
                    </td>
                    <td >
                      <span *ngFor="let d of director.depositDetails; "><ul  style="list-style-type:none;padding-left: 8px;"><li>{{d.dateOfDeposit | date : "dd-MM-y"}}</li></ul></span>
                    </td>
                    <td>
                      <span *ngFor="let d of director.depositDetails; "><ul  style="list-style-type:none;padding-left: 8px;"><li>{{d.typeOfDeposit}}</li></ul></span>
                    </td>
                    <td>
                      <span *ngFor="let d of director.depositDetails; "><ul  style="list-style-type:none;padding-left: 8px;"><li>{{d.amount}}</li></ul></span>
                    </td>
                    <td>
                      {{director.depositorRecipt}}
                    </td>
                    <td>
                      <span *ngIf="director.depositorType=='BodyCorporate'">Body Corporate</span>
                      <span *ngIf="director.depositorType=='Individual'">Individual</span>
                    </td>
                    
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" (click)="editDepositor(director._id)" class="btn-sm btn btn-warning"
                        [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)"
                        [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete depositor details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteDepositor()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>